import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import ErrorBoundary from './Components/ErrorBoundary/ErrorBoundary';
import { initAnalytics } from './firebase/analytics';
import { initPerformance } from './firebase/performance';
import { fetchRemoteConfig } from './firebase/remoteConfig';
import { refreshSiteSettings } from './firebase/siteSettings';
import { silentCatch } from './utils/errorHandler';

const originalConsoleError = console.error;
console.error = function (...args) {
  if (typeof args[0] === 'string' && args[0].includes('BloomFilter error')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

window.addEventListener('unhandledrejection', (event) => {
  const err = event.reason;
  if (err && err.code === 'permission-denied') {
    console.warn('Firestore permission-denied (suppressed):', err.message);
    event.preventDefault();
  }
});

window.addEventListener('error', (event) => {
  if (
    event.message &&
    event.message.includes(
      "Cannot read properties of undefined (reading 'startTime')"
    )
  ) {
    event.preventDefault();
  }
});

initAnalytics();
initPerformance();
fetchRemoteConfig().catch(silentCatch('index:fetchRemoteConfig'));
refreshSiteSettings().catch(silentCatch('index:refreshSiteSettings'));

if (
  'serviceWorker' in navigator &&
  (import.meta.env?.PROD || process.env.NODE_ENV === 'production')
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        console.log('SW registered:', reg.scope);
      })
      .catch((err) => {
        console.warn('SW registration failed:', err);
      });
  });
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </ErrorBoundary>
);
